// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bgs_a","AdSlotBranding__desktop":"bgs_b","AdSlotBranding__mobile":"bgs_c"};